"use client"

import type { ReactNode } from "react"

import { CarouselDots, Reel, Row } from "@/components/ui"
import { useReelPagination } from "@/lib/hooks/use-reel-pagination"

interface FeedRowProps {
  count: number
  gridTemplateColumns: string
  children: ReactNode
}

// The reel half of a row, extracted only because a pager needs client state. The members
// stay server components: they arrive as `children` already rendered, so nothing inside a
// section ships to the browser for the sake of three dots.
//
// Below the row's grid step the members travel as a reel; from it they are grid tracks and
// nothing scrolls, so `overflowing` goes false and the pager disappears on its own. The
// @5xl:hidden is belt and braces for the frame between the resize observer and the paint.
export const FeedRow = ({ count, gridTemplateColumns, children }: FeedRowProps) => {
  const { ref, index, stops, overflowing, goTo } = useReelPagination(count)
  return (
    <>
      <Reel ref={ref} gap="300" snap inset className="@5xl:grid @5xl:gap-500 @5xl:overflow-visible" style={{ gridTemplateColumns }}>
        {children}
      </Reel>
      {overflowing && (
        <Row justify="center" className="mt-300 @5xl:hidden">
          <CarouselDots tone="plain" activeColor="bg-brand" count={stops} index={index} onChange={goTo} />
        </Row>
      )}
    </>
  )
}
